import { Pipe, PipeTransform } from '@angular/core';

const MINUTES_PER_HOUR = 60;

@Pipe({
  name: 'duration',
  standalone: true,
  pure: true,
})
export class DurationPipe implements PipeTransform {
  transform(minutes: number | null | undefined): string {
    if (minutes === null || minutes === undefined || minutes < 0) {
      return '-';
    }

    const roundedMinutes = Math.round(minutes);

    if (roundedMinutes < MINUTES_PER_HOUR) {
      return `${ roundedMinutes } min`;
    }

    const hours = Math.floor(roundedMinutes / MINUTES_PER_HOUR);
    const remainingMinutes = roundedMinutes % MINUTES_PER_HOUR;

    if (remainingMinutes === 0) {
      return `${ hours } h`;
    }

    return `${ hours } h ${ remainingMinutes } min`;
  }
}
